import type { SelectOption, SelectOptionWithColor } from './SelectOption';

export const isSelectOptionWithColor = (
  selectOption: SelectOption | SelectOptionWithColor
): selectOption is SelectOptionWithColor => {
  return typeof selectOption === 'object' && 'color' in selectOption;
};
